export default "__VITE_ASSET__0e3f71e6__"